var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"width":"200px","position":"absolute","z-index":"20"}},[_c('Float_menu')],1),_c('div',{staticStyle:{"height":"100%","display":"flex","align-items":"center"}},[_c('div',{ref:"DC_HQ_5F",style:({
        width: '100%',
        height: '920px',
        backgroundImage: 'url(' + this.backgroud_png + ') ',
        backgroundRepeat: 'no-repeat',
        marginLeft: '200px',
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }